// extracted by mini-css-extract-plugin
module.exports = {"base":"navbar_base__Jg8qG","wrapper":"navbar_wrapper__M4BeJ","navbar":"navbar_navbar__WYH4Q"};